import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import {
  makeStyles,
  Typography,
  Button,
  DialogContent,
  Slide,
} from "@material-ui/core";
import Close from "../../assets/images/close.png";
import "./dashboard.css";

const useStyles = makeStyles((theme) => ({
  close: {
    position: "absolute",
    [theme.breakpoints.down("sm")]: {
      top: 2,
      right: 0,
    },
  },
  heading: {
    color: "#3D3D3D",
    fontFamily: "Roboto",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
  },
  descriptionBox: {
    marginTop: "5px",
  },
}));

const InfoPopup = ({ open, closeModalHandler, infoDesc, ...props }) => {
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      fullWidth="md"
      PaperProps={{
        style: { top: 0 },
      }}
    >
      <Button
        variant="text"
        className={classes.close}
        onClick={closeModalHandler}
      >
        <img width="15px" src={Close} alt="close" />
      </Button>
      <DialogContent>
        <div className={classes.heading}>
          {" "}
          {props.login ? "Alert" : "Notifications"}{" "}
        </div>
        <div className={classes.descriptionBox}>{infoDesc}</div>
      </DialogContent>
    </Dialog>
  );
};

export default InfoPopup;
